import readingImg from "assets/images/reading-coming-soon.svg";
import textCompreImg from "assets/images/text-comprehension-coming-soon.svg";
import vocabularyImg from "assets/images/vocab-coming-soon.svg";
import { type ComingSoonModules, ModuleType } from "models/product/ProductDetails";
import { HstProducts } from "./hst-constants";

export const HstProductsWithPlaceholderModules = [HstProducts.DUTCH];

// TODO: add subscription URL when available
export const getComingSoonModules = (t: (key: string) => string): ComingSoonModules[] => [
  {
    title: t("homepage:studentDashboard.comingSoonModules.comingSoonModulesPage.vocabulary.title"),
    description: t(
      "homepage:studentDashboard.comingSoonModules.comingSoonModulesPage.vocabulary.description",
    ),
    type: ModuleType.VOCABULARY,
    subscriptionUrl:
      "https://forms.monday.com/forms/dfa34dfdf825c81fbfea3221ffd0a2d8?r=use1&woordenschat=&hogeschooltaal=",
    imageAsset: vocabularyImg,
    learningItems: [
      {
        icon: "fal fa-book",
        text: t(
          "studentDashboard.comingSoonModules.comingSoonModulesPage.vocabulary.learningItem1",
        ),
      },
      {
        icon: "far fa-bullseye-arrow",
        text: t(
          "studentDashboard.comingSoonModules.comingSoonModulesPage.vocabulary.learningItem2",
        ),
      },
      {
        icon: "far fa-chart-line",
        text: t(
          "studentDashboard.comingSoonModules.comingSoonModulesPage.vocabulary.learningItem3",
        ),
      },
    ],
  },
  {
    title: t("homepage:studentDashboard.comingSoonModules.comingSoonModulesPage.reading.title"),
    description: t(
      "homepage:studentDashboard.comingSoonModules.comingSoonModulesPage.reading.description",
    ),
    type: ModuleType.READING,
    subscriptionUrl:
      "https://forms.monday.com/forms/9a5b734eb986c7ce2a1f66262e49903e?r=use1&lezen=&hogeschooltaal=",
    imageAsset: readingImg,
    learningItems: [
      {
        icon: "far fa-books",
        text: t("studentDashboard.comingSoonModules.comingSoonModulesPage.reading.learningItem1"),
      },
      {
        icon: "far fa-search",
        text: t("studentDashboard.comingSoonModules.comingSoonModulesPage.reading.learningItem2"),
      },
      {
        icon: "far fa-chart-line",
        text: t("studentDashboard.comingSoonModules.comingSoonModulesPage.reading.learningItem3"),
      },
    ],
  },
  {
    title: t(
      "homepage:studentDashboard.comingSoonModules.comingSoonModulesPage.text-comprehension.title",
    ),
    description: t(
      "homepage:studentDashboard.comingSoonModules.comingSoonModulesPage.text-comprehension.description",
    ),
    type: ModuleType.TEXT_COMPREHENSION,
    subscriptionUrl:
      "https://forms.monday.com/forms/89db4825fc8906fcc0ade1739b1d0413?r=use1&teksbegrip=&hogeschooltaal=",
    imageAsset: textCompreImg,
    learningItems: [
      {
        icon: "fas fa-book",
        text: t(
          "studentDashboard.comingSoonModules.comingSoonModulesPage.text-comprehension.learningItem1",
        ),
      },
      {
        icon: "far fa-lightbulb",
        text: t(
          "studentDashboard.comingSoonModules.comingSoonModulesPage.text-comprehension.learningItem2",
        ),
      },
      {
        icon: "far fa-bullseye-arrow",
        text: t(
          "studentDashboard.comingSoonModules.comingSoonModulesPage.text-comprehension.learningItem3",
        ),
      },
    ],
  },
];
